import { useLang } from "hooks/useLang"

function getCountdownDays() {
    const targetDate = new Date("2025-04-18")
    const today = new Date()

    // Calculate the difference in milliseconds
    const diffTime = targetDate.getTime() - today.getTime()

    // Convert milliseconds to days
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    return diffDays
}

const F1CountDays = () => {
    const { t } = useLang()
    return (
        <div className="flex mt-1 gap-1">
            <span className="light:text-[#000] dark:text-[#fff]  text-[24px] uppercase font-bold">
                {t("comingIn")}
            </span>
            <span className={`text-[#FFC700] text-[24px] capitalize  font-bold`}>
                <div className="mr-1 ml-1  flex-row flex">

                    {`${getCountdownDays() >= 0 ? getCountdownDays() : 0} ${t("days")}`}
                </div>
            </span>
        </div>
    )
}

export default F1CountDays
